module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.episode.id),
      expression: "episode.id"
    }]
  }, [_c('div', {
    staticClass: "ep-data"
  }, [_c('img', {
    attrs: {
      "src": _vm.episodeImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ep-data-text"
  }, [_c('p', [_c('strong', [_vm._v("S" + _vm._s(_vm.episode.airedSeason) + "E" + _vm._s(_vm.episode.airedEpisodeNumber) + " - " + _vm._s(_vm.episode.episodeName))])]), _vm._v(" "), _c('p', [_c('small', [(_vm.lastSeen < Date.now() - 1000) ? _c('span', [_vm._v("Last viewed: " + _vm._s(new Date(_vm.episode.viewedAt)))]) : _vm._e()])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.episode.overview))]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.episode.playLinks.netflix,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('h3', [_vm._v("Play in Netflix!")])])])])]), _vm._v(" "), _c('drinking-rules')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2de651d9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Episode.vue
// module id = 37
// module chunks = 0